import Analytics from './main';
import MixpanelProvider from './providers/mixpanel';

/**
  * Import default analytics setup where analytics is needed.
  * e.g. const analytics = setupAnalytics();
  */
export const setupAnalytics = () => {
    const defaultProvider = new MixpanelProvider();

    return new Analytics(defaultProvider);
};
